module.exports = __webpack_public_path__ + "img/200305.601135ff.png";